import { Container, Grid } from "@mui/material";
import React, { FunctionComponent } from "react";

type HeaderBodyTemplateProps = {
    header: React.ReactNode;
    body: React.ReactNode;
  }

const HeaderBodyTemplate: FunctionComponent<HeaderBodyTemplateProps> = ({header, body}) => {
  return (
    <Container>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          {header}  
        </Grid>
        <Grid item xs={12}>
          {body}
        </Grid>
      </Grid>
    </Container>
  );
};

export default HeaderBodyTemplate;